module.exports = __webpack_public_path__ + "static/media/nora.7fb26650.jpg";